import { render, staticRenderFns } from "./ContentHorizontalRule.vue?vue&type=template&id=079be300&scoped=true&"
import script from "./ContentHorizontalRule.vue?vue&type=script&lang=js&"
export * from "./ContentHorizontalRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079be300",
  null
  
)

export default component.exports